export default __webpack_public_path__ + "static/media/hht2_ep_10.e138b386.png";